import { Radio } from "antd";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface RadioButtonRankingOptionsProps {
  value: string;
}

const RadioButtonRankingOptions: React.FC<RadioButtonRankingOptionsProps> = (
  props
) => {
  const { value } = props;
  const history = useHistory();
  const { t } = useTranslation("radar");

  return (
    <Radio.Group value={value}>
      <Radio.Button
        value="artist"
        onClick={() => history.push("/artist-ranking")}
      >
        {t("pages.ArtistsRanking.artistsRanking")}
      </Radio.Button>
      <Radio.Button value="role" onClick={() => history.push("/role-ranking")}>
        {t("pages.ArtistsRanking.roleRanking")}
      </Radio.Button>
      <Radio.Button
        value="release"
        onClick={() => history.push("/releases-ranking")}
      >
        {t("pages.ArtistsRanking.releasesRanking")}
      </Radio.Button>

      <Radio.Button
        value="track"
        onClick={() => history.push("/tracks-ranking")}
      >
        {t("pages.ArtistsRanking.tracksRanking")}
      </Radio.Button>

      <Radio.Button
        value="label"
        onClick={() => history.push("/labels-ranking")}
      >
        {t("pages.ArtistsRanking.labelsRanking")}
      </Radio.Button>
    </Radio.Group>
  );
};

export default RadioButtonRankingOptions;
